import React, { useContext, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useKeyDown } from 'hooks/use-keydown';
import { UIContext } from 'context/ui';
import { CloseButton } from 'components/close-button/CloseButton';

import s from './Search.scss';

interface IProps {
  children?: React.ReactNode;
}

const DURATION = 500;

export const Search = ({ children }: IProps) => {
  const { searchOpen, toggleSearch } = useContext<any>(UIContext);
  const searchRef = useRef<HTMLDivElement>(null);

  const keys = useKeyDown();

  useEffect(() => {
    if (!searchOpen) {
      return;
    }
    if (keys.includes('Esc') || keys.includes('Escape')) {
      toggleSearch(false);
    }
  }, [keys]);

  return (
    <CSSTransition
      in={searchOpen}
      timeout={DURATION}
      unmountOnExit
      classNames={{
        enter: s.searchEnter,
        enterActive: s.searchEnterActive,
        exit: s.searchExit,
        exitActive: s.searchExitActive,
      }}
    >
      <div tabIndex={0} ref={searchRef} className={s('search', { open: searchOpen })}>
        <div className={s.search__header}>
          <CloseButton onClick={() => toggleSearch(false)}>Close</CloseButton>
        </div>
        {children}
      </div>
    </CSSTransition>
  );
};
